import CreateOwner from './CreateOwner';

export default CreateOwner;
